/* import __COLOCATED_TEMPLATE__ from './sla-breach-config.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import Component from '@glimmer/component';
import { action } from '@ember/object';

interface CustomBotWithBotData {
  botData: {
    get(key: string): unknown;
    set(key: string, value: unknown): void;
  };
}

interface Args {
  customBot: CustomBotWithBotData;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class SlaBreachConfig extends Component<Signature> {
  get delayInSeconds() {
    return this.args.customBot.botData.get('delayInSeconds');
  }

  get slaTargetType() {
    return this.args.customBot.botData.get('slaTargetType');
  }

  @action
  setSlaTargetType(type: string) {
    this.args.customBot.botData.set('slaTargetType', type);
  }

  @action
  setDelayInSeconds(value: number) {
    this.args.customBot.botData.set('delayInSeconds', Number(value));
  }
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::TriggerInfoNode::SlaBreachConfig': typeof SlaBreachConfig;
    'workflows/graph-editor/trigger-info-node/sla-breach-config': typeof SlaBreachConfig;
  }
}
